import "../../sources/js/functions/countdown";
import {getCookie} from "../../sources/js/functions/helpers";

(function () {
    const countdown = document.querySelector('[data-countdown]')
    const timers = document.querySelectorAll('[data-timer]')
    const currentLanguage = getCookie('current_language')
    const daysLabel = currentLanguage === 'en' ? 'days' : 'දින'
    const hoursLabel = currentLanguage === 'en' ? 'hours' : 'පැය'
    const minutesLabel = currentLanguage === 'en' ? 'minutes' : 'මිනිත්තු'
    const secondsLabel = currentLanguage === 'en' ? 'seconds' : 'තත්පර'
    const finishLabel = currentLanguage === 'en' ? 'Finished' : 'අවසන්'
    const leftLabel = currentLanguage === 'en' ? 'left' : 'ඉතිරි'

    if (countdown) {
        const endDate = new Date(+countdown.dataset.end * 1000)
        const endDateTime = new Date(endDate.toLocaleString('en-US', {timeZone: 'Asia/Colombo'}))
        const msgAfter = `<li class="finish"><span class="title-large">${finishLabel}</span></li>`
        const msgPattern =
            `<li><span class="title-large">{days}</span> <span class="body-thin">${daysLabel}</span></li><li class="separator">:</li>` +
            `<li><span class="title-large">{hours}</span> <span class="body-thin">${hoursLabel}</span></li><li class="separator">:</li>` +
            `<li><span class="title-large">{minutes}</span> <span class="body-thin">${minutesLabel}</span></li><li class="separator">:</li>` +
            `<li><span class="title-large">{seconds}</span> <span class="body-thin">${secondsLabel}</span></li>`

        new Countdown({
            selector: '.countdown',
            leadingZeros: true,
            msgAfter: msgAfter,
            msgPattern: msgPattern,
            dateEnd: endDateTime
        });
    }

    if (timers) {
        timers.forEach((timer, i) => {
            const id = timer.dataset.id
            const endDate = new Date(+timer.dataset.end * 1000)
            const endDateTime = new Date(endDate.toLocaleString('en-US', {timeZone: 'Asia/Colombo'}))
            const msgAfter = finishLabel
            const msgPattern = `{days} ${daysLabel} {hours} ${hoursLabel} ${leftLabel}`

            new Countdown({
                selector: `.countdown-${id}`,
                msgAfter: msgAfter,
                msgPattern: msgPattern,
                dateEnd: endDateTime
            });
        })
    }
}());
